import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const AdsRemainderText = styled.div<React.CSSProperties>`
  bottom: ${40 * Screen.widthRatio}px;
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${36 * Screen.widthRatio}px;
  left: ${54 * Screen.widthRatio}px;
  position: absolute;
`;

export default AdsRemainderText;
